import { render, staticRenderFns } from "./IFESimpleSelect.vue?vue&type=template&id=475ca042&scoped=true"
import script from "./IFESimpleSelect.vue?vue&type=script&lang=js"
export * from "./IFESimpleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475ca042",
  null
  
)

export default component.exports